/* Picardo landing: hero, sticky, przed i po, karuzela. Delegacja na dokumencie, zakres przez sekcję. */
(function () {
  if (window.__pcMain) return;
  window.__pcMain = true;

  var fmt = new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' });
  function money(cents) { return fmt.format(cents / 100); }
  function sec(el) { return el && el.closest('[data-pc-section]'); }
  function heroForm() { return document.querySelector('[data-pc-form]'); }

  /* HERO: wybór wariantu przyciskami, zdjęcie zmienia się z wariantem */
  function selectVariant(btn) {
    var s = sec(btn), form = s.querySelector('[data-pc-form]');
    s.querySelectorAll('[data-pc-variant]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    form.querySelector('[data-pc-variant-input]').value = btn.getAttribute('data-pc-variant');
    var price = +btn.getAttribute('data-price'), was = +btn.getAttribute('data-was');
    s.querySelector('[data-pc-price]').textContent = money(price);
    var w = s.querySelector('[data-pc-was]');
    if (w) { if (was > price) { w.textContent = money(was); w.hidden = false; } else { w.hidden = true; } }
    var img = btn.getAttribute('data-img'), main = s.querySelector('[data-pc-main-img]');
    if (img && main) main.src = img;
    document.querySelectorAll('[data-pc-sticky-price]').forEach(function (el) { el.textContent = money(price); });
    var url = new URL(window.location.href); url.searchParams.set('variant', btn.getAttribute('data-pc-variant'));
    window.history.replaceState({}, '', url.toString());
  }

  /* HERO: data imprezy, najwcześniej za 2 dni, uczciwe ostrzeżenie przy krótkim terminie */
  function isoDate(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function initDates() {
    document.querySelectorAll('[data-pc-date]').forEach(function (inp) {
      if (inp.dataset.pcReady) return; inp.dataset.pcReady = '1';
      var min = new Date(); min.setDate(min.getDate() + 2);
      inp.min = isoDate(min);
      var note = inp.parentNode.querySelector('[data-pc-date-msg]');
      if (note) inp.dataset.pcNote = note.textContent;
    });
  }
  function checkDate(inp) {
    var note = inp.parentNode.querySelector('[data-pc-date-msg]'); if (!note || !inp.value) return;
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var d = new Date(inp.value + 'T00:00:00'), days = Math.round((d - today) / 86400000);
    if (days < 4) note.textContent = 'Termin jest krótki. Zamów i od razu napisz do nas na WhatsApp (883 040 200), a potwierdzimy, czy zdążymy. Jeśli nie zdążymy, oddamy pieniądze.';
    else note.textContent = inp.dataset.pcNote || '';
  }

  /* HERO: dodanie do koszyka jednym kliknięciem, z dodatkiem, potem przejście do koszyka */
  function addToCart(form) {
    var btn = form.querySelector('[data-pc-submit]'), msg = form.querySelector('[data-pc-msg]');
    var date = form.querySelector('[data-pc-date]');
    if (date && !date.value) { date.focus(); msg.textContent = 'Podaj datę imprezy, żebyśmy zdążyli.'; msg.classList.add('pc-msg--err'); return; }
    btn.disabled = true; msg.textContent = 'Dodaję do koszyka...'; msg.classList.remove('pc-msg--err');
    var bump = form.querySelector('[data-pc-bump]'), bumpId = form.getAttribute('data-bump-id');
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' }
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Błąd'); });
      if (bump && bump.checked && bumpId) {
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: +bumpId, quantity: 1 }] }) });
      }
    }).then(function () {
      window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
    }).catch(function (err) {
      btn.disabled = false; msg.textContent = 'Nie udało się dodać do koszyka: ' + err.message; msg.classList.add('pc-msg--err');
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var v = t.closest('[data-pc-variant]'); if (v && !v.disabled) { selectVariant(v); return; }
    var th = t.closest('[data-pc-thumb]');
    if (th) {
      var s = sec(th), main = s.querySelector('[data-pc-main-img]'); if (main) main.src = th.getAttribute('data-pc-thumb');
      s.querySelectorAll('[data-pc-thumb]').forEach(function (b) { b.setAttribute('aria-current', b === th ? 'true' : 'false'); });
      return;
    }
    if (t.closest('[data-pc-sticky-buy]')) {
      var f = heroForm(); if (!f) return;
      var date = f.querySelector('[data-pc-date]');
      if (date && !date.value) { f.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { date.focus(); }, 400); }
      else addToCart(f);
      return;
    }
    var dot = t.closest('[data-pc-dot]');
    if (dot) {
      var sc = sec(dot), car = sc.querySelector('[data-pc-carousel]'), item = car.children[+dot.getAttribute('data-pc-dot')];
      if (item) car.scrollTo({ left: item.offsetLeft - (car.clientWidth - item.clientWidth) / 2, behavior: 'smooth' });
    }
  });

  document.addEventListener('submit', function (e) {
    if (!e.target.matches('[data-pc-form]')) return;
    if (!window.fetch || !window.FormData) return; // bez JS formularz działa zwykłym wysłaniem
    e.preventDefault(); addToCart(e.target);
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-pc-date]')) checkDate(t);
    if (t.matches('[data-pc-photo]')) {
      var m = t.closest('form').querySelector('[data-pc-file-msg]');
      if (m && t.files[0]) m.textContent = 'Zdjęcie dołączone: ' + t.files[0].name + '. Przed drukiem wyślemy Ci podgląd projektu.';
    }
  });

  /* PRZED I PO */
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-pc-ba-range]')) return;
    e.target.closest('[data-pc-ba]').style.setProperty('--pc-pos', e.target.value + '%');
  });

  /* KARUZELA: kropki śledzą przewijanie, osobno dla każdej sekcji */
  document.addEventListener('scroll', function (e) {
    var car = e.target; if (!car.matches || !car.matches('[data-pc-carousel]')) return;
    var s = sec(car), center = car.scrollLeft + car.clientWidth / 2, best = 0, dist = Infinity;
    Array.prototype.forEach.call(car.children, function (c, i) {
      var d = Math.abs(c.offsetLeft + c.clientWidth / 2 - center); if (d < dist) { dist = d; best = i; }
    });
    s.querySelectorAll('[data-pc-dot]').forEach(function (b, i) { b.setAttribute('aria-current', i === best ? 'true' : 'false'); });
  }, true);

  /* STICKY: widoczny, gdy przycisk w hero zniknie z ekranu */
  function initSticky() {
    var bar = document.querySelector('[data-pc-sticky]'), btn = document.querySelector('[data-pc-submit]');
    if (!bar || !btn || !('IntersectionObserver' in window) || bar.dataset.pcReady) return;
    bar.dataset.pcReady = '1';
    new IntersectionObserver(function (en) { bar.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(btn);
  }

  function init() { initDates(); initSticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();